@import '../../../../../styles/global/global-imports';

:host {
  @include appendColorPalette(background);

  h3 {
    font-size: $font-size-28;
    line-height: $font-size-32;
    margin: 0 0 12px 0;
  }

  div {
    padding: 1rem 1.5rem;
    margin-bottom: 1.5rem;
    background: var(---tableOfContentsBackgroundColor);
  }
}

@include breakpoint(minmd) {
  :host {
    h3 {
      font-size: $font-size-32;
      line-height: $font-size-40;
      margin: 0 0 12px 0;
    }
  }
}
